import React, { Component, Fragment } from 'react';


class NotFound extends Component {
    render() {
        return (
            <Fragment>
                Not Found
            </Fragment>
        );
    }
}

export default NotFound;